import { render, staticRenderFns } from "./RepeatersView.vue?vue&type=template&id=0241e93f&"
import script from "./RepeatersView.vue?vue&type=script&lang=js&"
export * from "./RepeatersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports